export const SET_REDIRECT_URI = 'SET_REDIRECT_URI'
export const SHOW_ACTION_PENDING = 'SHOW_ACTION_PENDING'
export const TOGGLE_ACTION_PENDING = 'TOGGLE_ACTION_PENDING'
